import { render, staticRenderFns } from "./InvoiceQuery.vue?vue&type=template&id=838adf8c&scoped=true&"
import script from "./InvoiceQuery.vue?vue&type=script&lang=js&"
export * from "./InvoiceQuery.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceQuery.vue?vue&type=style&index=0&id=838adf8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838adf8c",
  null
  
)

export default component.exports